export default __webpack_public_path__ + "static/media/center_icon_B.c7601545.svg";